export function topicsYearPcFunc() {
    var jsAccordion, jsF, aTagTxt, setTxt;
    jsAccordion = '#jsAccordion';
    jsF = '#jsF';
    $(jsAccordion).on({
        'mouseenter': function () {
            $(this).find('#jsF').stop().slideDown("slow");
            $(this).find('li').eq(0).addClass("arrowOn");
        },
        'mouseleave': function () {
            $(this).find('#jsF').stop().slideUp("slow");
            $(this).find('li').eq(0).removeClass("arrowOn");
        }
    });
}

export function topicsYearSpFunc() {
    var jsAccordion, jsF, aTagTxt, setTxt;
    jsAccordion = '#jsAccordion';
    jsF = '#jsF';
    $(jsAccordion).on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).find('#jsF').stop().slideUp("slow");
            $(this).find('li').eq(0).removeClass("arrowOn");
        } else {
            $(this).addClass('active');
            $(this).find('#jsF').stop().slideDown("slow");
            $(this).find('li').eq(0).addClass("arrowOn");
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/js/pages/_topics.js
// module id = 14
// module chunks = 0